import dayjs from 'dayjs';
import type {FeedPost, SocialAccount as SocialAccountType} from "~/repository/types";
import Model from "~/repository/models/Model";

export default class SocialAccount extends Model<SocialAccountType>() implements SocialAccountType {
    id = 0;
    created_at: string;
    name: string;
    provider: "instagram";
    updated_at: string;
    user_id: number;

    constructor(data: SocialAccountType) {
        super()
        this.created_at = data.created_at
        this.name = data.name
        this.provider = data.provider
        this.updated_at = data.updated_at
        this.user_id = data.user_id
    }

    get href(): string {
        if (this.provider === 'instagram') {
            return `https://instagram.com/${this.name}`
        }
        return '';
    }
}
